module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "reply-box"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.reply),
      expression: "reply",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "您的回复会被公开展示，请注意措辞"
    },
    domProps: {
      "value": (_vm.reply)
    },
    on: {
      "keyup": _vm.changeFontNum,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reply = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('footer', [_c('span', [_vm._v("已经输入" + _vm._s(_vm.fontNum) + "个字，共可以输入500字")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "提交",
      "disabled": _vm.submitStatus
    },
    on: {
      "click": _vm.submitReply
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "取消"
    },
    on: {
      "click": _vm.hideReply
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664bd588","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/comment/list/components/list/Reply.vue
// module id = 722
// module chunks = 0